// extracted by mini-css-extract-plugin
module.exports = {"TheLoading":"Loading_TheLoading__7Mls5","theLoading":"Loading_TheLoading__7Mls5"};